<h2 mat-dialog-title>Enviar WhatsApp{{ data?.context ? ' - ' + data.context : '' }}</h2>
<div mat-dialog-content class="whatsapp-edit">
  <form [formGroup]="form">
    <div>
      <div style="display:flex; align-items:center; gap:8px;">
        <label>Para</label>
        <button mat-icon-button type="button" color="primary"
                matTooltip="Consultar celular no Cadastro"
                (click)="toggleCadastroLookup()">
          <mat-icon>search</mat-icon>
        </button>
      </div>

      <!-- Lookup Cadastro (celular) -->
      <div *ngIf="showCadastroLookup" class="txtadd-lookup-panel">
        <div style="display:flex; align-items:center; gap:8px; margin-bottom:6px;">
          <mat-form-field style="flex:1" appearance="outline">
            <mat-label>Pesquisar cadastro (nome, CPF/CNPJ)</mat-label>
            <input matInput [value]="cadastroSearch" (input)="onCadastroSearchChange($event.target.value)" autocomplete="off" />
          </mat-form-field>
          <button mat-icon-button type="button" color="warn" matTooltip="Fechar" (click)="showCadastroLookup = false">
            <mat-icon>close</mat-icon>
          </button>
        </div>
        <div class="txtadd-lookup-list">
          <div *ngIf="cadastroLoading" style="text-align:center; padding:12px;">Carregando...</div>
          <div *ngIf="!cadastroLoading && cadastroResults.length === 0" style="text-align:center; padding:12px; color:#888;">
            Nenhum cadastro encontrado
          </div>
          <table *ngIf="!cadastroLoading && cadastroResults.length > 0" class="txtadd-lookup-table">
            <thead>
              <tr>
                <th style="width:60px">Código</th>
                <th>Nome</th>
                <th style="width:120px">Celular</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of cadastroResults" (click)="selectCadastro(item)" class="txtadd-lookup-row"
                  matTooltip="{{ item.razaoSocial }}">
                <td>{{ item.id?.toString().padStart(5, '0') }}</td>
                <td>{{ getCadastroNome(item) }}</td>
                <td>{{ item.celular || item.telefone1 || item.telefone2 || '-' }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <input formControlName="to" placeholder="Número ou destinatário (vários separados por ;)" />
    </div>

    <div>
      <div style="display:flex; align-items:center; gap:8px;">
        <label>Mensagem</label>
        <button mat-icon-button type="button" color="primary"
                matTooltip="Consultar Texto Adicional"
                (click)="toggleTxtAddLookup()">
          <mat-icon>search</mat-icon>
        </button>
      </div>

      <!-- Lookup Texto Adicional -->
      <div *ngIf="showTxtAddLookup" class="txtadd-lookup-panel">
        <div style="display:flex; align-items:center; gap:8px; margin-bottom:6px;">
          <mat-form-field style="flex:1" appearance="outline">
            <mat-label>Pesquisar texto adicional</mat-label>
            <input matInput [value]="txtAddSearch" (input)="onTxtAddSearchChange($event.target.value)" autocomplete="off" />
          </mat-form-field>
          <button mat-icon-button type="button" color="warn" matTooltip="Fechar" (click)="showTxtAddLookup = false">
            <mat-icon>close</mat-icon>
          </button>
        </div>
        <div class="txtadd-lookup-list">
          <div *ngIf="txtAddLoading" style="text-align:center; padding:12px;">Carregando...</div>
          <div *ngIf="!txtAddLoading && txtAddResults.length === 0" style="text-align:center; padding:12px; color:#888;">
            Nenhum texto adicional encontrado
          </div>
          <table *ngIf="!txtAddLoading && txtAddResults.length > 0" class="txtadd-lookup-table">
            <thead>
              <tr>
                <th style="width:60px">Código</th>
                <th>Descrição</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of txtAddResults" (click)="selectTxtAdd(item)" class="txtadd-lookup-row"
                  matTooltip="{{ item.texto }}">
                <td>{{ (item.codigo ?? item.id)?.toString().padStart(5, '0') }}</td>
                <td>{{ item.descricao }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <textarea formControlName="message" rows="6"></textarea>
    </div>

    <!-- Checkbox 'enviar assunto' removido -->

    <div>
      <label>Anexos (mídia)</label>
      <input type="file" (change)="onFilesSelected($event)" multiple />
    </div>

    <div *ngIf="attachments.length">
      <h4>Anexos</h4>
      <ul>
        <li *ngFor="let a of attachments; let i = index">
          {{ a.name }} ({{ a.size }} bytes)
          <button type="button" (click)="removeAttachment(i)">Remover</button>
        </li>
      </ul>
    </div>

    <!-- Sem nomes não há o que substituir: tudo sairia como "Cliente" -->
    <div *ngIf="semNomes" class="arte-bloco arte-bloco-alerta">
      <mat-icon>warning</mat-icon>
      Os destinatários chegaram sem nome, então a personalização por nome não está disponível.
      Abra o envio pela lista de Cadastros (marcando os registros) para habilitar.
    </div>

    <!-- Arte personalizada: só aparece com imagem anexada e destinatários com nome -->
    <div *ngIf="podePersonalizar" class="arte-bloco">
      <button mat-stroked-button type="button" color="primary" (click)="personalizarArte()">
        <mat-icon>auto_fix_high</mat-icon>
        {{ modeloArte ? 'Ajustar personalização' : 'Personalizar arte por destinatário' }}
      </button>

      <span *ngIf="modeloArte" class="arte-bloco-resumo">
        {{ resumoPersonalizacao }}
        <button mat-icon-button type="button" (click)="removerPersonalizacao()"
                matTooltip="Enviar a arte sem personalizar">
          <mat-icon>close</mat-icon>
        </button>
      </span>
      <span *ngIf="!modeloArte" class="arte-bloco-dica">
        {{ dicaPersonalizacao }} ({{ qtdeComNome }} com nome)
      </span>
    </div>
  </form>
</div>
<div mat-dialog-actions align="end">
  <div style="flex: 1; text-align: left;">
    <button *ngIf="showRetryOption && lastErrors.length > 0" 
            mat-button color="warn" 
            (click)="copiarErrosParaClipboard()"
            [disabled]="sending || retrying"
            matTooltip="Copiar detalhes dos erros para suporte">
      <mat-icon>content_copy</mat-icon>
      Copiar Erros
    </button>
    <button *ngIf="showRetryOption && lastErrors.length > 0" 
            mat-button color="accent" 
            (click)="reenviarFalhas()"
            [disabled]="sending || retrying"
            matTooltip="Reenviar apenas as mensagens que falharam">
      <mat-icon>refresh</mat-icon>
      Reenviar Falhas
    </button>
  </div>
  <button mat-button (click)="cancel()">Fechar</button>
  <button mat-flat-button color="primary" (click)="send()" [disabled]="sending || retrying">
    <mat-progress-spinner *ngIf="sending || retrying" [diameter]="18" mode="indeterminate" class="sending-spinner"></mat-progress-spinner>
    {{ sending ? 'Enviando...' : (retrying ? 'Reenviando...' : 'Enviar') }}
  </button>
</div>
